import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  active: {
    backgroundColor: theme.palette.hover2,
  },
}))

export default useStyles
